
import { useState } from 'react';

import { useObserver } from 'mobx-react';

import { useIsomorphicLayoutEffect } from '@lib/hooks';
import { useStore } from '@store/index';

const useCoinListStore = () => {
  const {
    withdrawalStore: { fetchAssetCoinList }
  } = useStore();
  return useObserver(() => ({
    fetchAssetCoinList
  }))
}

export const useCanDeposit = (currency: string) => {
  const { fetchAssetCoinList } = useCoinListStore()
  const [showDepositButton, setShowDepositButton] = useState<boolean>(false)

  useIsomorphicLayoutEffect(() => {
    const fetch = async () => {
      const res = await fetchAssetCoinList({ checkType: 'enableDeposit' });
      const showDepositButton = res?.map(i => {
        if (i.currency === currency) {
          const assetsList = i?.assets?.filter(item => item.enableDeposit === true) ?? [];
          if (assetsList?.length > 0 || !(assetsList?.length === 1 && assetsList[0]?.chainType === 'FIAT')) {
            return true;
          };
        }
        return false;
      });
      setShowDepositButton(showDepositButton)
    }
    fetch()
  }, [currency])
  return [showDepositButton]
}
